import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import { TICKET_STATE, TicketStateString } from '../../model/Ticket/TicketConstants';

interface TicketStateTagProps {
  ticketState: TICKET_STATE;
}

const TicketStateTag = (props: TicketStateTagProps) => {
  const { t } = useTranslation();
  const { ticketState } = props;

  return (
    <Tag
      color={
        ticketState == TICKET_STATE.CLOSED
          ? 'default'
          : ticketState === TICKET_STATE.RESOLVED
            ? 'green'
            : ticketState === TICKET_STATE.OPEN || ticketState == TICKET_STATE.REOPENED
              ? 'blue'
              : 'default'
      }
      className={'TicketStateTag'}>
      {t(TicketStateString[ticketState])}
    </Tag>
  );
};

export default TicketStateTag;
